(function () {
  if (window.__sbInlineReviewModuleReady) return;
  window.__sbInlineReviewModuleReady = true;

  var AVATAR_URL = 'https://cdn.shopify.com/s/files/1/0986/4973/5501/files/superbonsai-review-author-01.png?v=1788254573';

  var copy = {
    nl: {
      label: 'Samengestelde klantervaring',
      review: 'Binnen de eerste week begon ik verschil te merken. Ik voelde me minder opgeblazen en minder opgezet. Door het consequent te gebruiken voelde mijn spijsvertering prettiger en had ik meer energie gedurende de dag. De druppels zijn makkelijk in te nemen en smaken aangenaam, waardoor ze eenvoudig onderdeel van mijn dagelijkse routine zijn geworden.',
      note: 'Samengesteld uit meerdere geverifieerde klantreviews. Ervaringen verschillen per persoon.',
      alt: 'Illustratieve klantavatar met Super Liver',
      stars: '5 van 5 sterren'
    },
    de: {
      label: 'Zusammengefasste Kundenerfahrung',
      review: 'Innerhalb der ersten Woche begann ich bereits einen Unterschied zu bemerken. Ich fühlte mich weniger aufgebläht und weniger aufgeschwemmt. Bei konsequenter Anwendung fühlte sich meine Verdauung angenehmer an und ich hatte im Alltag mehr Energie. Die Tropfen sind einfach einzunehmen und schmecken angenehm, sodass sie leicht Teil meiner täglichen Routine wurden.',
      note: 'Zusammengefasst aus mehreren verifizierten Kundenbewertungen. Erfahrungen können von Person zu Person variieren.',
      alt: 'Illustrative Kundenabbildung mit Super Liver',
      stars: '5 von 5 Sternen'
    },
    en: {
      label: 'Combined customer experience',
      review: 'Within the first week I started noticing a difference. I felt less bloated and less puffy. After staying consistent, my digestion felt more comfortable and I had more day-to-day energy. The drops are easy to take and the taste is pleasant, which made them simple to build into my daily routine.',
      note: 'Combined from multiple verified customer reviews. Individual experiences may vary.',
      alt: 'Illustrative customer image holding Super Liver',
      stars: '5 out of 5 stars'
    }
  };

  function locale() {
    var code = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return copy[code] ? code : 'en';
  }

  function isSuperBonsaiProduct() {
    var body = document.body;
    var html = document.documentElement;
    if (!body) return false;
    var productPage = body.classList.contains('template-product') ||
      body.className.indexOf('template-product') !== -1 ||
      !!document.querySelector('[id^="MainProduct-"], .product__info-container, .product__info-wrapper');
    if (!productPage) return false;
    var host = (window.location.hostname || '').toLowerCase();
    var commerceHost = (html.getAttribute('data-commerce-host') || '').toLowerCase();
    return host.indexOf('superbonsai') !== -1 || commerceHost.indexOf('superbonsai') !== -1 || body.classList.contains('sb-site');
  }

  function addStyles() {
    if (document.getElementById('SuperBonsaiInlineReviewStyles')) return;
    var style = document.createElement('style');
    style.id = 'SuperBonsaiInlineReviewStyles';
    style.textContent = [
      '#SuperBonsaiInlineReview{margin:16px 0 20px;padding:16px;border:1px solid rgba(16,44,36,.12);border-radius:16px;background:#fcf9f1;color:#102c24;box-sizing:border-box}',
      '#SuperBonsaiInlineReview .sb-ir__top{display:flex;align-items:flex-start;gap:14px}',
      '#SuperBonsaiInlineReview .sb-ir__avatar{width:88px;height:88px;flex:0 0 88px;border-radius:14px;overflow:hidden;background:#f3efe5}',
      '#SuperBonsaiInlineReview .sb-ir__avatar img{display:block;width:100%;height:100%;object-fit:cover;object-position:center}',
      '#SuperBonsaiInlineReview .sb-ir__body{min-width:0;flex:1}',
      '#SuperBonsaiInlineReview .sb-ir__label{margin:0 0 5px;font-size:12px;line-height:1.25;font-weight:750;letter-spacing:.04em;text-transform:uppercase;color:#516953}',
      '#SuperBonsaiInlineReview .sb-ir__stars{margin:0 0 8px;font-size:17px;line-height:1;letter-spacing:1px;color:#d8a800}',
      '#SuperBonsaiInlineReview .sb-ir__review{margin:0;font-size:14px;line-height:1.55;color:#102c24}',
      '#SuperBonsaiInlineReview .sb-ir__note{margin:11px 0 0;padding-top:10px;border-top:1px solid rgba(16,44,36,.1);font-size:11.5px;line-height:1.4;color:rgba(16,44,36,.68)}',
      '@media(max-width:749px){#SuperBonsaiInlineReview{padding:14px;margin-top:14px}#SuperBonsaiInlineReview .sb-ir__top{gap:12px}#SuperBonsaiInlineReview .sb-ir__avatar{width:76px;height:76px;flex-basis:76px}#SuperBonsaiInlineReview .sb-ir__review{font-size:13.5px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function productInfo() {
    return document.querySelector('.product__info-container') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('[id^="ProductInfo-"]');
  }

  function paymentAnchor(info) {
    if (!info) return null;
    var selectors = [
      '.payment-badges',
      '.product__payment-badges',
      '.list-payment',
      '[class*="payment-badges"]',
      '[class*="payment_badges"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var node = info.querySelector(selectors[i]);
      if (node) return node.closest('.product__block, .product-form__buttons, [class*="payment-badges"]') || node;
    }
    return null;
  }

  function buildReview() {
    var t = copy[locale()];
    var wrap = document.createElement('aside');
    wrap.id = 'SuperBonsaiInlineReview';
    wrap.setAttribute('aria-label', t.label);
    wrap.innerHTML =
      '<div class="sb-ir__top">' +
        '<div class="sb-ir__avatar"><img src="' + AVATAR_URL + '" alt="' + t.alt + '" width="176" height="176" loading="lazy"></div>' +
        '<div class="sb-ir__body">' +
          '<p class="sb-ir__label">' + t.label + '</p>' +
          '<div class="sb-ir__stars" role="img" aria-label="' + t.stars + '">★★★★★</div>' +
          '<p class="sb-ir__review">“' + t.review + '”</p>' +
        '</div>' +
      '</div>' +
      '<p class="sb-ir__note">' + t.note + '</p>';
    return wrap;
  }

  function apply() {
    if (!isSuperBonsaiProduct()) return false;
    var existing = document.getElementById('SuperBonsaiInlineReview');
    if (existing) return true;
    var info = productInfo();
    var anchor = paymentAnchor(info);
    if (!info || !anchor) return false;
    addStyles();
    anchor.insertAdjacentElement('afterend', buildReview());
    return true;
  }

  function run() {
    apply();
    window.setTimeout(apply, 250);
    window.setTimeout(apply, 700);
    window.setTimeout(apply, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
